require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/fn/symbol/iterator.js
// module id = 600
// module chunks = 168707334958949